import { Box, Text, Link, List, Icon } from "@chakra-ui/react";
import { LuGlobe, LuPodcast } from "react-icons/lu";
import { categoryItems } from "../helpers";
import type { SearchResult } from "../interfaces";

const iconMap = categoryItems.reduce(
  (acc, item) => {
    acc[item.label] = item.icon;
    return acc;
  },
  {} as Record<string, any>,
);

const ResultIcon = ({ result }: { result: SearchResult }) => {
  if (result.type === "episode") {
    return <Icon as={LuPodcast} mr={3} boxSize={5} color="gray.500" />;
  }
  const IconComponent =
    (result.category && iconMap[result.category]) || LuGlobe;
  return <Icon as={IconComponent} mr={3} boxSize={5} color="gray.500" />;
};

interface SearchResultsProps {
  results: SearchResult[];
  onItemClick?: () => void;
  isModalLayout?: boolean;
}

export function SearchResults({
  results,
  onItemClick,
  isModalLayout = false,
}: SearchResultsProps) {
  return (
    <List.Root variant="plain" colorPalette="blue">
      {results.map((result, index) => (
        <List.Item
          key={result.content_id}
          _hover={{ bg: "blackAlpha.50" }}
          borderRadius={isModalLayout ? "md" : 0}
          borderBottomWidth={
            !isModalLayout && index < results.length - 1 ? "1px" : "0"
          }
        >
          <Link
            href={
              result.type === "recommendation"
                ? result.url
                : `/episode/${result.episode_number}`
            }
            _hover={{ textDecoration: "none" }}
            display="flex"
            alignItems="center"
            w="full"
            p={isModalLayout ? 2 : 3}
            onClick={onItemClick}
          >
            <ResultIcon result={result} />
            <Box>
              <Text fontWeight="medium" color="chakra-body-text">
                {result.title}
              </Text>
              {result.body && (
                <Text
                  fontSize="sm"
                  color="gray.500"
                  dangerouslySetInnerHTML={{ __html: result.body }}
                />
              )}
            </Box>
          </Link>
        </List.Item>
      ))}
    </List.Root>
  );
}
